import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SEMANTIC, UI } from '../../styles/theme';
import KycProgressBar from '../KycProgressBar';
import API from '../../api';

const EmailVerification = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');
  const { t } = useTranslation();

  const sendCode = async () => {
    try {
      await API.post('/kyc/send-email-code', { user_id: userId });
    } catch (err) {
      setError(t('kyc.email.error_generic'));
    }
  };

  useEffect(() => {
    sendCode();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await API.post('/kyc/verify-email', { user_id: userId, code });
      setSuccess(true);
      setTimeout(() => {
        navigate('/kyc/phone-verification');
      }, 1000);
    } catch (err) {
      setError(err.response?.data?.message || t('kyc.email.error_generic'));
    }
  };

  const handleResend = () => {
    setError('');
    sendCode();
  };

  return (
    <div
      style={{
        backgroundColor: SEMANTIC.backgroundApp,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        padding: UI.spacing.lg,
      }}
    >
      <div style={{ maxWidth: '500px', margin: '0 auto', width: '100%' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: UI.spacing.xl }}>
          <img
            src={`${process.env.PUBLIC_URL}/Logo_Kuesto.png`}
            alt="Kuesto Logo"
            style={{ width: '120px' }}
          />
        </div>

        {/* Progress Bar */}
        <KycProgressBar currentStep={1} />

        {/* Card */}
        <div
          style={{
            backgroundColor: SEMANTIC.backgroundCard,
            borderRadius: UI.borderRadius.md,
            padding: UI.spacing.xl,
            boxShadow: UI.shadow.card,
          }}
        >
          <h2
            style={{
              color: SEMANTIC.actionBuy,
              marginBottom: UI.spacing.md,
              fontSize: UI.fontSize.title,
              fontWeight: UI.fontWeight.bold,
              textAlign: 'center',
            }}
          >
            {t('kyc.email.title')}
          </h2>
          <p
            style={{
              color: SEMANTIC.textSecondary,
              marginBottom: UI.spacing.xl,
              textAlign: 'center',
              fontSize: UI.fontSize.md,
            }}
          >
            {t('kyc.email.description')}
          </p>

          {success && (
            <div
              style={{
                backgroundColor: 'rgba(0, 255, 136, 0.1)',
                border: `2px solid ${SEMANTIC.actionBuy}`,
                borderRadius: UI.borderRadius.sm,
                padding: UI.spacing.md,
                marginBottom: UI.spacing.lg,
                color: SEMANTIC.actionBuy,
                textAlign: 'center',
              }}
            >
              {t('kyc.email.success')}
            </div>
          )}

          {error && (
            <div
              style={{
                backgroundColor: 'rgba(255, 77, 77, 0.1)',
                border: `2px solid ${SEMANTIC.actionSell}`,
                borderRadius: UI.borderRadius.sm,
                padding: UI.spacing.md,
                marginBottom: UI.spacing.lg,
                color: SEMANTIC.actionSell,
                textAlign: 'center',
              }}
            >
              {error}
            </div>
          )}

          <form onSubmit={handleVerify}>
            <div style={{ marginBottom: UI.spacing.lg }}>
              <label
                htmlFor="code"
                style={{
                  color: SEMANTIC.textPrimary,
                  display: 'block',
                  marginBottom: UI.spacing.sm,
                  fontSize: UI.fontSize.md,
                  fontWeight: UI.fontWeight.bold,
                }}
              >
                {t('kyc.email.code_label')}
              </label>
              <input
                type="text"
                id="code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="______"
                maxLength="6"
                required
                style={{
                  width: '100%',
                  padding: UI.spacing.md,
                  backgroundColor: SEMANTIC.backgroundCard,
                  color: SEMANTIC.textPrimary,
                  border: '1px solid rgba(255,255,255,0.15)',
                  borderRadius: UI.borderRadius.sm,
                  fontSize: UI.fontSize.lg,
                  textAlign: 'center',
                  letterSpacing: '0.5em',
                }}
              />
            </div>
            <button
              type="submit"
              disabled={code.length !== 6}
              style={{
                width: '100%',
                padding: UI.spacing.md,
                backgroundColor:
                  code.length === 6
                    ? SEMANTIC.ctaPrimary
                    : SEMANTIC.backgroundDisabled,
                color:
                  code.length === 6
                    ? SEMANTIC.ctaPrimaryText
                    : SEMANTIC.textDisabled,
                border: 'none',
                borderRadius: UI.borderRadius.sm,
                fontSize: UI.fontSize.lg,
                fontWeight: UI.fontWeight.bold,
                cursor: code.length === 6 ? 'pointer' : 'not-allowed',
                transition: UI.transition.fast,
              }}
            >
              {t('kyc.email.button')}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: UI.spacing.lg }}>
            <button
              onClick={handleResend}
              style={{
                background: 'transparent',
                border: 'none',
                color: SEMANTIC.actionBuy,
                fontSize: UI.fontSize.md,
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              {t('kyc.email.resend')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
